import { NgModule } from '@angular/core';
import { ErrorSnackBarComponent } from './error-snack-bar/error-snack-bar.component';

import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule, TranslateModule.forChild(), ErrorSnackBarComponent],
  exports: [ErrorSnackBarComponent]
})
export class ErrorHandlingModule {}
